import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FrequencyMap, WeekdayMap } from '@services/appsync/mappings';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useCheckoutCashflowViewModel } from '../../../models/CheckoutCashflowViewModel';

export const Schedule: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const viewModel = useCheckoutCashflowViewModel();

  let secondaryContent;
  switch (viewModel.frequency) {
    case FrequencyMap.ONE:
    case FrequencyMap.BI_MONTHLY:
    case FrequencyMap.DAILY:
      secondaryContent = null;
      break;
    case FrequencyMap.WEEKLY:
      secondaryContent = (
        <>
          <TextBlock mt={'24px'}>Day of week</TextBlock>
          <Select
            value={viewModel.dayOfWeek ?? WeekdayMap.MONDAY}
            onChange={(e) => {
              viewModel.setDayOfWeek(parseInt(e.target.value));
            }}>
            {[
              WeekdayMap.MONDAY,
              WeekdayMap.TUESDAY,
              WeekdayMap.WEDNESDAY,
              WeekdayMap.THURSDAY,
              WeekdayMap.FRIDAY,
              WeekdayMap.SATURDAY,
              WeekdayMap.SUNDAY,
            ].map((day) => (
              <option key={`dayOfWeek-${day}`} value={day}>
                {viewModel.getDayNameByNumber(day)}
              </option>
            ))}
          </Select>
        </>
      );
      break;
    case FrequencyMap.MONTHLY:
      secondaryContent = (
        <>
          <TextBlock mt={'24px'}>Day of month</TextBlock>
          <Select
            defaultValue={viewModel.daysOfMonth && viewModel.daysOfMonth.length > 0 ? viewModel.daysOfMonth[0] : 1}
            onChange={(e) => viewModel.setDaysOfMonth([parseInt(e.target.value)])}>
            {[...Array(28).keys()].map((day) => (
              <option key={`day-${day}`} value={day + 1}>
                {day + 1}
              </option>
            ))}
          </Select>
        </>
      );
      break;
  }
  return (
    <Flex
      onClick={onOpen}
      alignItems={'center'}
      borderRadius={'10px'}
      justifyContent="space-between"
      p={'24px'}
      borderWidth={'1px'}
      borderColor="grey.300">
      <Flex alignItems={'center'}>
        <Icon fontSize={'24px'} color="blue.500" icon="calendar" variant="regular" />
        <TextBlock weight={'bold'} borderStyle={'dashed'} borderBottomWidth="2px" borderBottomColor="black" ml="20px">
          {viewModel.getFrequencyDescription()}
        </TextBlock>
      </Flex>
      <Icon fontSize={'24px'} icon="caret-right" variant="solid" color="blue.500" />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader borderBottomWidth={'1px'} borderBottomStyle="solid" textAlign={'center'}>
            Select Frequency and Date
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TextBlock mt={'24px'}>Frequency</TextBlock>
            <Select
              defaultValue={viewModel.frequency ?? FrequencyMap.ONE}
              onChange={(e) => {
                viewModel.setFrequency(e.target.value as FrequencyMap);
              }}>
              <option value={FrequencyMap.ONE}>One-time</option>
              <option value={FrequencyMap.DAILY}>Daily</option>
              <option value={FrequencyMap.WEEKLY}>Weekly</option>
              <option value={FrequencyMap.BI_MONTHLY}>Bi-Monthly</option>
              <option value={FrequencyMap.MONTHLY}>Monthly</option>
            </Select>
            {secondaryContent}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" w="full" onClick={onClose}>
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};
